"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var expression_eval_1 = require("expression-eval");
var traverse_1 = require("./traverse");
var utils_1 = require("./utils");
exports.createExpressionCompiler = function (config) { return function (map) {
    try {
        return Object.keys(map).reduce(function (acc, path) {
            var _a;
            var node = expression_eval_1.parse(map[path]);
            var value = typeof config.visitor === 'function'
                ? traverse_1.traverse(node, config.visitor)
                : node;
            return __assign({}, acc, (_a = {}, _a[path] = value, _a));
        }, {});
    }
    catch (e) {
        utils_1.throwError(e, config.errorOnEval);
        return {};
    }
}; };
//# sourceMappingURL=compiler.js.map